module.exports = __webpack_public_path__ + "img/nav05_h.6452586b.png";